import { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { useUpdateQuizProfileMutation } from "../../slices/fun_stuff/quizUsersSlice";
import { useUpdateUserPasswordMutation } from "../../slices/fun_stuff/quizAdminSlice";
import { setQuizCredentials } from "../../slices/fun_stuff/quizAuthSlice";
import { toast } from 'react-toastify';
import Loader from "../Loader";

const UpdateInfo = ({ setShow, admin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [email, setEmail] = useState('');

    const [updateProfile, { isLoading: loadingUpdateProfile }] = useUpdateQuizProfileMutation();
    const [adminUpdatePassword, { isLoading: adminUpdateLoading }] = useUpdateUserPasswordMutation();

    const dispatch = useDispatch();
    

    const submitHandler = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
        toast.error('Passwords do not match');
        } else {
            const data = {
                username, 
                password, 
                email,
            }
            try {
                let res;
                if (admin) {
                    res = await adminUpdatePassword(data).unwrap();
                    toast.success(res.message);
                } else {
                    res = await updateProfile(data).unwrap();
                    dispatch(setQuizCredentials(res));
                    toast.success('Profile updated');
                    setShow && setShow(false);
                }
            } catch (error) {
                toast.error(error?.data?.message || error.error);
            }
        }
    }

    return (
        <div className="update-info">
            <h2 className='mt-3'>{`Update ${admin && 'User'} Info`}</h2>
            <Form onSubmit={submitHandler} className="update-profile-form mb-4">

                <Form.Group controlId="username" className="my-2" style={{ maxWidth: '300px' }}>
                    <Form.Label>Update Username</Form.Label>
                    <Form.Control
                    type='name'
                    placeholder="Enter username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}>
                    </Form.Control>
                </Form.Group>

                <Form.Group controlId="password" className="my-2" style={{ maxWidth: '300px' }}>
                    <Form.Label>Update Password</Form.Label>
                    <Form.Control
                    type='password'
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}>
                    </Form.Control>
                </Form.Group>

                <Form.Group controlId="confirm-password" className="my-2" style={{ maxWidth: '300px' }}>
                    <Form.Label>Confirm Password</Form.Label>
                    <Form.Control
                    type='password'
                    placeholder="Confirm password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}>
                    </Form.Control>
                </Form.Group>

                {!admin && 
                <Form.Group controlId='email' className='my-1' style={{ maxWidth: '250px' }}>
                    <Form.Label>Email - <p className="my-0 small">*Optional, will be used for password recovery</p></Form.Label>
                    <Form.Control 
                    type='email'
                    placeholder='Email (optional)'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}>
                    </Form.Control>
                </Form.Group>}
        
                <Button type="submit" variant="primary" className="my-2">
                    Update
                </Button>
                { (loadingUpdateProfile || adminUpdateLoading) && <Loader />}
            </Form>
        </div>
    );
}

export default UpdateInfo